import React from 'react';
import PropTypes from 'prop-types';
import LoadingSpinner from '../themes/svg/loadingSpinner';

const Loading = props => (
  <div className={`loading${props.isLoading ? ' visible' : ' invisible'}`}>
    <LoadingSpinner />
  </div>
);

Loading.propTypes = {
  isLoading: PropTypes.bool,
};

Loading.defaultProps = {
  isLoading: false,
};

export default Loading;
